// This file is auto-generated by the generateModuleTranslationKeys Vite plugin.
// Do not edit this file manually.
import { useTypedTranslation } from "@/shared/culture/useTypedTranslation";

export const COMMON_TRANSLATIONS = {
  "apps.alerting": "Alerting",
  "apps.captain": "Captain",
  "apps.dashboards": "Dashboards",
  "apps.devices": "Devices",
  "apps.identityAndAccess": "Identity & access",
  "apps.organiser": "Organiser",
  "apps.reporting": "Reporting",
  "apps.resources": "Resources",
  "apps.sources": "Sources",
  "apps.storageHub": "Storage Hub",
  "apps.support": "Support",
  "apps.uns": "UNS",
  "auth.accessDenied": "Access Denied",
  "auth.keepLoggedIn": "Keep me logged in",
  "auth.login.or": "OR",
  "auth.login.password": "Password",
  "auth.login.signIn": "Sign in",
  "auth.login.signInWithMicrosoft": "Sign in with Microsoft",
  "auth.login.usernameOrEmail": "Username/email",
  "auth.loginRequired": "Login Required",
  "auth.sessionExpired": "Session expired",
  "auth.sessionExpiring": "Your session is about to expire.",
  "auth.unauthorized": "You don't have access to this page.",
  "common.activationId": "Activation ID",
  "common.activeVersion": "Active version",
  "common.add": "Add",
  "common.addDocumentationHere": "Add documentation here...",
  "common.addVariable": "Add Variable",
  "common.alerts": "Alerts",
  "common.all": "All",
  "common.autoUpdate": "Auto-update",
  "common.availableForSubcompanies": "Available for subcompanies",
  "common.back": "Back",
  "common.blob": "Blob",
  "common.blobStore": "BlobStore",
  "common.boolean": "Boolean",
  "common.busy": "Busy",
  "common.cancel": "Cancel",
  "common.cleanup": "Clean up",
  "common.close": "Close",
  "common.cloudStorage": "Cloud Storage",
  "common.company": "Company",
  "common.component": "Component",
  "common.configuration": "Configuration",
  "common.configurations": "Configurations",
  "common.confirm": "Confirm",
  "common.confirmDelete": "Are you sure you want to delete this item?",
  "common.connection": "Connection",
  "common.continue": "Continue",
  "common.coordinates": "Coordinates",
  "common.copiedToClipboard": "Copied to clipboard",
  "common.copyToClipboard": "Copy to clipboard",
  "common.cpu": "CPU",
  "common.create": "Create",
  "common.createdBy": "Created by",
  "common.current": "Current",
  "common.currentVersion": "Current version",
  "common.darkMode": "Dark mode",
  "common.dashboards": "Dashboards",
  "common.database": "Database",
  "common.dataExplorer": "Data Explorer",
  "common.dateCreated": "Date created",
  "common.delete": "Delete",
  "common.deleteConfirmation": "Delete Confirmation",
  "common.description": "Description",
  "common.discard": "Discard",
  "common.disk": "Disk",
  "common.documentation": "Documentation",
  "common.downgrade": "Downgrade",
  "common.download": "Download",
  "common.downloadSuccessful": "Download successful",
  "common.duration": "Duration",
  "common.edgeGateways": "Edge gateways",
  "common.edit": "Edit",
  "common.enabled": "Enabled",
  "common.enterColor": "Enter color",
  "common.enterEmail": "Enter email",
  "common.enterEmailOrGroup": "Enter email or group",
  "common.enterPeriodInMinutes": "Enter period in min",
  "common.enterTeam": "Enter team",
  "common.error": "Error",
  "common.favorite": "Favorite",
  "common.files": "Files",
  "common.fleet": "Fleet",
  "common.fleets": "Fleets",
  "common.folders": "Folders",
  "common.from": "From",
  "common.general": "General",
  "common.goBack": "Go back",
  "common.goToHome": "Go to Home",
  "common.home": "Home",
  "common.id": "ID",
  "common.influx": "Influx",
  "common.info": "Info",
  "common.installedVersion": "Installed Version",
  "common.invalidHexValue": "Invalid hex value",
  "common.invalidInput": "Invalid input",
  "common.item": "Item",
  "common.key": "Key",
  "common.latestVersion": "Latest version",
  "common.licenses": "Licenses",
  "common.lightMode": "Light mode",
  "common.linkedDatabases": "Linked databases",
  "common.loading": "Loading...",
  "common.logs": "Logs",
  "common.measurement": "Measurement",
  "common.memory": "Memory",
  "common.messages": "Messages",
  "common.metadata": "Metadata",
  "common.name": "Name",
  "common.new": "New",
  "common.next": "Next",
  "common.no": "No",
  "common.noChangesDetected": "No changes detected",
  "common.noConfiguration": "No configuration",
  "common.noData": "No data",
  "common.noDataAlert": "No-data alert",
  "common.noItems": "No items found.",
  "common.noName": "No name",
  "common.noResults": "No results found",
  "common.noVersion": "No version",
  "common.number": "Number",
  "common.offline": "Offline",
  "common.ok": "OK",
  "common.online": "Online",
  "common.open": "Open",
  "common.openColorPicker": "Open color picker",
  "common.options": "Options",
  "common.os": "OS",
  "common.overview": "Overview",
  "common.permissions": "Permissions",
  "common.postfix": "Postfix",
  "common.previous": "Previous",
  "common.previousVersions": "Previous versions",
  "common.projects": "Projects",
  "common.refresh": "Refresh",
  "common.reinstall": "Reinstall",
  "common.remove": "Remove",
  "common.reports": "Reports",
  "common.required": "This field is required",
  "common.requiredLabel": "Required",
  "common.resources": "Resources",
  "common.retentionName": "Retention Name",
  "common.retentions": "Retentions",
  "common.save": "Save",
  "common.saveChanges": "Save Changes",
  "common.schedule": "Schedule",
  "common.search": "Search",
  "common.selectCompany": "Select a Company",
  "common.selectConfiguration": "Select configuration",
  "common.selectFleet": "Select fleet",
  "common.selectOrCreateVariableKey": "Select or create a variable key",
  "common.selectSource": "Select source",
  "common.selectVersion": "Select version",
  "common.settings": "Settings",
  "common.showLess": "Show less",
  "common.showMore": "Show more",
  "common.someFieldsInvalid": "Some fields are invalid",
  "common.status": "Status",
  "common.string": "String",
  "common.submit": "Submit",
  "common.submitting": "Submitting...",
  "common.success": "Success",
  "common.summary": "Summary",
  "common.tags": "Tags",
  "common.templates": "Templates",
  "common.timescale": "Timescale",
  "common.timestamp": "Timestamp",
  "common.timestampHuman": "Timestamp (human)",
  "common.to": "To",
  "common.totalPoints": "Total Points",
  "common.tryAgain": "Try again",
  "common.type": "Type",
  "common.typePlural": "Types",
  "common.unfavorite": "Unfavorite",
  "common.unit": "Unit",
  "common.unknown": "Unknown",
  "common.unlink": "Unlink",
  "common.update": "Update",
  "common.upToDate": "Up to date",
  "common.url": "URL",
  "common.userFallback": "User",
  "common.value": "Value",
  "common.variables": "Variables",
  "common.version": "Version",
  "common.view": "View",
  "common.warning": "Warning",
  "common.yes": "Yes",
  "dialog.closeAriaLabel": "Close dialog",
  "errors.chunkLoadDescription":
    "This part of the app couldn't be loaded. This can happen after an update or due to a temporary connection issue. Refreshing the page usually resolves the problem.",
  "errors.chunkLoadTitle": "We're having trouble loading this page",
  "errors.componentStack": "Component Stack",
  "errors.copyErrorDetails": "Copy Error Details",
  "errors.crashTitle": "Oops! Something went wrong.",
  "errors.default": "An error occurred. Please try again.",
  "errors.framesSuffix": "frames",
  "errors.networkError": "Network error. Please check your connection.",
  "errors.notFound": "Resource not found.",
  "errors.serverError": "Server error. Please try again later.",
  "errors.sourceFrame": "Source",
  "errors.stackTrace": "Stack Trace",
  "errors.timeout": "Request timeout. Please try again.",
  "errors.unexpectedError": "An unexpected error occurred",
  "errors.validation": "Validation error. Please check your input.",
  "errors.viewTechnicalDetails": "View technical details",
  "home.applications": "Applications",
  "home.editApps": "Edit apps",
  "home.tagline":
    "Manage your data, create reports and dashboards, and much more.",
  "home.warnings.apiTokens.contactAdmin":
    "Contact your admin to renew API tokens.",
  "home.warnings.apiTokens.message":
    "{{count}} API tokens are nearing their expiration dates. To avoid any disruption to your service, please extend the tokens as soon as possible.",
  "home.warnings.apiTokens.title": "API tokens expiring or invalid",
  "home.warnings.blobstoreTokens.contactAdmin":
    "Contact your admin to fix blobstore tokens.",
  "home.warnings.blobstoreTokens.message":
    "{{count}} blobstores have a token that is nearing its expiration date. To avoid any disruption to your service, please update the tokens as soon as possible.",
  "home.warnings.blobstoreTokens.title": "Blobstore tokens expiring or invalid",
  "home.warnings.deviceLicenses.contactAdmin":
    "Contact your admin to renew device licenses.",
  "home.warnings.deviceLicenses.message":
    "{{count}} devices have a license that is nearing its expiration date. To avoid any disruption to your service, please extend the licenses as soon as possible.",
  "home.warnings.deviceLicenses.title": "Device licenses expiring or invalid",
  "home.welcome": "Welcome",
  "layout.goToHomepage": "Go to Homepage",
  "layout.notFoundDescription": "The page you are looking for does not exist.",
  "layout.notFoundTitle": "Not Found",
  "navigation.admin": "Admin",
  "navigation.applications": "Applications",
  "navigation.profile": "Profile",
  "overview.result": "result",
  "overview.results": "results",
  "placeholders.editVariable": "Edit Variable",
  "placeholders.enterDuration": "Enter duration",
  "placeholders.enterPostfix": "Enter postfix",
  "placeholders.enterRetentionName": "Enter retention name",
  "platformAdmin.announcementCreatedSuccess":
    "Announcement created successfully",
  "platformAdmin.announcementDeletedSuccess":
    "Announcement deleted successfully",
  "platformAdmin.logoutSuccess": "Logout successful",
  "platformAdmin.pushLoggerConfigFailed": "Failed to push logger config",
  "platformAdmin.pushLoggerConfigSuccess":
    "Successfully pushed edge gateway configuration",
  "platformAdmin.updatePushedSuccess": "Update pushed successfully",
  "resources.types.ArtifactBundle": "Artifact Bundle",
  "resources.types.Documentation": "Documentation",
  "resources.types.Files": "Files",
  "resources.types.Image": "Image",
  "resources.types.Installer": "Installer",
  "resources.types.SoftwareUpdate": "Software Update",
  "select.company": "Company",
  "select.enterOrSelectTag": "Enter or select a tag",
  "select.enterTag": "Enter a tag",
  "select.folder": "Folder",
  "select.metadataBundlePlaceholder": "Select metadatabundle",
  "select.retentionsPlaceholder": "Select database retentions",
  "select.role": "Role",
  "select.tags": "Tags",
  "topbar.admin": "Admin",
  "topbar.logout": "Logout",
  "topbar.notifications": "Notifications",
  "topbar.notificationsAllRead": "All notifications have been read",
  "topbar.notificationsClearAll": "Clear all notifications",
  "topbar.notificationsDismiss": "Dismiss notification",
  "topbar.notificationsEmpty": "Nothing to see here",
  "topbar.notificationsMarkAllRead": "Mark all notifications as read",
  "topbar.notificationsOpen": "Open notification",
  "topbar.notificationsView": "View notification",
  "topbar.privacyPolicy": "Privacy Policy",
  "topbar.profile": "Profile",
  "topbar.responsibleDisclosure": "Responsible Disclosure",
  "topbar.skipToMain": "Skip to main content",
  "topbar.termsOfUse": "Terms of Use",
  "topbar.userMenu": "User menu",
  "unsavedChanges.message":
    "You have made changes. Do you want to save or discard them?",
  "unsavedChanges.title": "Review changes",
  "validation.atLeastOneValueRequired": "At least one value is required",
  "validation.duplicateTagKeys": "Duplicate tag keys:",
  "validation.email": "Please enter a valid email address",
  "validation.keyRequired": "Key is required",
  "validation.maxLength": "Must not exceed {max} characters",
  "validation.minLength": "Must be at least {min} characters",
  "validation.nameMax50": "Name must be 50 characters or fewer",
  "validation.namePatternSimple":
    "Name can only contain letters, numbers, hyphens and underscores",
  "validation.namePatternWithSpaces":
    "Name can only contain letters, numbers, spaces, underscores, and hyphens",
  "validation.nameRequired": "Name is required",
  "validation.number": "Must be a number",
  "validation.pattern": "Invalid format",
  "validation.required": "This field is required",
  "validation.url": "Please enter a valid URL",
  "validation.valueCannotBeEmpty": "Value cannot be empty",
} as const;

export const COMMON_PLURAL_KEYS = {
  "home.warnings.apiTokens.message": true,
  "home.warnings.blobstoreTokens.message": true,
  "home.warnings.deviceLicenses.message": true,
} as const;

export type CommonTranslationKey = keyof typeof COMMON_TRANSLATIONS;
export type CommonPluralTranslationKey = keyof typeof COMMON_PLURAL_KEYS;

/**
 * Typed translation hook for shared/global keys (navigation, topbar, common, etc.).
 * For module-specific keys, use useTypedTranslation<YourModuleTranslationKey>() instead.
 */
export function useCommonTranslation() {
  return useTypedTranslation<
    CommonTranslationKey,
    typeof COMMON_TRANSLATIONS,
    CommonPluralTranslationKey
  >(COMMON_TRANSLATIONS, COMMON_PLURAL_KEYS);
}
